// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.14.0 (commit 3ac273e970212dd613e57f4c312c49a9ab8ccb50).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AddBugReportRepoReducer from "./add_bug_report_repo_reducer";
import BackfillIssueNumbersFromUrlsReducer from "./backfill_issue_numbers_from_urls_reducer";
import ClearGithubAppInstallUrlReducer from "./clear_github_app_install_url_reducer";
import ClearOrgGithubConfigReducer from "./clear_org_github_config_reducer";
import ClearWebclientBaseUrlReducer from "./clear_webclient_base_url_reducer";
import CloseBugReportReducer from "./close_bug_report_reducer";
import LinkBugReportToGithubReducer from "./link_bug_report_to_github_reducer";
import LinkBugReportToRepoReducer from "./link_bug_report_to_repo_reducer";
import PingReducer from "./ping_reducer";
import PostCommentReducer from "./post_comment_reducer";
import PostRestoreNormalizeReducer from "./post_restore_normalize_reducer";
import ReconcileBugReportReducer from "./reconcile_bug_report_reducer";
import RegisterAttachmentReducer from "./register_attachment_reducer";
import RegisterImageAttachmentReducer from "./register_image_attachment_reducer";
import RemoveBugReportRepoReducer from "./remove_bug_report_repo_reducer";
import ReopenBugReportReducer from "./reopen_bug_report_reducer";
import SetBugReportBrokerConfigReducer from "./set_bug_report_broker_config_reducer";
import SetBugReportRepoSharedReducer from "./set_bug_report_repo_shared_reducer";
import SetDefaultGithubConfigReducer from "./set_default_github_config_reducer";
import SetDefaultInstallationReducer from "./set_default_installation_reducer";
import SetGithubAppConfigReducer from "./set_github_app_config_reducer";
import SetGithubAppInstallUrlReducer from "./set_github_app_install_url_reducer";
import SetInternalNotesReducer from "./set_internal_notes_reducer";
import SetModuleConfigReducer from "./set_module_config_reducer";
import SetOrgGithubConfigReducer from "./set_org_github_config_reducer";
import SetOrgInstallationReducer from "./set_org_installation_reducer";
import SetRepoVisibilityAllOrgsReducer from "./set_repo_visibility_all_orgs_reducer";
import SetServiceTokenReducer from "./set_service_token_reducer";
import SetWebclientBaseUrlReducer from "./set_webclient_base_url_reducer";
import SubmitBugReportReducer from "./submit_bug_report_reducer";
import SyncDeploymentConfigReducer from "./sync_deployment_config_reducer";
import TriageBugReportReducer from "./triage_bug_report_reducer";
import UnlinkBugReportReducer from "./unlink_bug_report_reducer";
import UpdateBugReportRepoReducer from "./update_bug_report_repo_reducer";
import UpdateUserProfileReducer from "./update_user_profile_reducer";
import VerifyBugReportRepoInstallReducer from "./verify_bug_report_repo_install_reducer";

// Import all procedure arg schemas
import * as AutoRegisterReposForInstallProcedure from "./auto_register_repos_for_install_procedure";
import * as RequestAttachmentDownloadUrlProcedure from "./request_attachment_download_url_procedure";
import * as RequestAttachmentUploadUrlProcedure from "./request_attachment_upload_url_procedure";
import * as RequestImageUploadUrlProcedure from "./request_image_upload_url_procedure";

// Import all table schema definitions
import AllBugReportAttachmentsRow from "./all_bug_report_attachments_table";
import AllBugReportCommentsRow from "./all_bug_report_comments_table";
import AllBugReportInternalsRow from "./all_bug_report_internals_table";
import AllBugReportsRow from "./all_bug_reports_table";
import ModuleConfigRow from "./module_config_table";
import MyBugReportAttachmentsRow from "./my_bug_report_attachments_table";
import MyBugReportCommentsRow from "./my_bug_report_comments_table";
import MyBugReportUserRow from "./my_bug_report_user_table";
import MyBugReportsRow from "./my_bug_reports_table";
import MyDeploymentConfigRow from "./my_deployment_config_table";
import MyGithubBugConfigRow from "./my_github_bug_config_table";
import OrgBugReportAttachmentsRow from "./org_bug_report_attachments_table";
import OrgBugReportCommentsRow from "./org_bug_report_comments_table";
import OrgBugReportInternalsRow from "./org_bug_report_internals_table";
import OrgBugReportUsersRow from "./org_bug_report_users_table";
import OrgBugReportsRow from "./org_bug_reports_table";
import VisibleBugReportReposRow from "./visible_bug_report_repos_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  moduleConfig: __table({
    name: 'module_config',
    indexes: [
      { accessor: 'id', name: 'module_config_id_idx_btree', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'module_config_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, ModuleConfigRow),
  allBugReportAttachments: __table({
    name: 'all_bug_report_attachments',
    indexes: [
    ],
    constraints: [
    ],
  }, AllBugReportAttachmentsRow),
  allBugReportComments: __table({
    name: 'all_bug_report_comments',
    indexes: [
    ],
    constraints: [
    ],
  }, AllBugReportCommentsRow),
  allBugReportInternals: __table({
    name: 'all_bug_report_internals',
    indexes: [
    ],
    constraints: [
    ],
  }, AllBugReportInternalsRow),
  allBugReports: __table({
    name: 'all_bug_reports',
    indexes: [
    ],
    constraints: [
    ],
  }, AllBugReportsRow),
  myBugReportAttachments: __table({
    name: 'my_bug_report_attachments',
    indexes: [
    ],
    constraints: [
    ],
  }, MyBugReportAttachmentsRow),
  myBugReportComments: __table({
    name: 'my_bug_report_comments',
    indexes: [
    ],
    constraints: [
    ],
  }, MyBugReportCommentsRow),
  myBugReportUser: __table({
    name: 'my_bug_report_user',
    indexes: [
    ],
    constraints: [
    ],
  }, MyBugReportUserRow),
  myBugReports: __table({
    name: 'my_bug_reports',
    indexes: [
    ],
    constraints: [
    ],
  }, MyBugReportsRow),
  myDeploymentConfig: __table({
    name: 'my_deployment_config',
    indexes: [
    ],
    constraints: [
    ],
  }, MyDeploymentConfigRow),
  myGithubBugConfig: __table({
    name: 'my_github_bug_config',
    indexes: [
    ],
    constraints: [
    ],
  }, MyGithubBugConfigRow),
  orgBugReportAttachments: __table({
    name: 'org_bug_report_attachments',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgBugReportAttachmentsRow),
  orgBugReportComments: __table({
    name: 'org_bug_report_comments',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgBugReportCommentsRow),
  orgBugReportInternals: __table({
    name: 'org_bug_report_internals',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgBugReportInternalsRow),
  orgBugReportUsers: __table({
    name: 'org_bug_report_users',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgBugReportUsersRow),
  orgBugReports: __table({
    name: 'org_bug_reports',
    indexes: [
    ],
    constraints: [
    ],
  }, OrgBugReportsRow),
  visibleBugReportRepos: __table({
    name: 'visible_bug_report_repos',
    indexes: [
    ],
    constraints: [
    ],
  }, VisibleBugReportReposRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("add_bug_report_repo", AddBugReportRepoReducer),
  __reducerSchema("backfill_issue_numbers_from_urls", BackfillIssueNumbersFromUrlsReducer),
  __reducerSchema("clear_github_app_install_url", ClearGithubAppInstallUrlReducer),
  __reducerSchema("clear_org_github_config", ClearOrgGithubConfigReducer),
  __reducerSchema("clear_webclient_base_url", ClearWebclientBaseUrlReducer),
  __reducerSchema("close_bug_report", CloseBugReportReducer),
  __reducerSchema("link_bug_report_to_github", LinkBugReportToGithubReducer),
  __reducerSchema("link_bug_report_to_repo", LinkBugReportToRepoReducer),
  __reducerSchema("ping", PingReducer),
  __reducerSchema("post_comment", PostCommentReducer),
  __reducerSchema("post_restore_normalize", PostRestoreNormalizeReducer),
  __reducerSchema("reconcile_bug_report", ReconcileBugReportReducer),
  __reducerSchema("register_attachment", RegisterAttachmentReducer),
  __reducerSchema("register_image_attachment", RegisterImageAttachmentReducer),
  __reducerSchema("remove_bug_report_repo", RemoveBugReportRepoReducer),
  __reducerSchema("reopen_bug_report", ReopenBugReportReducer),
  __reducerSchema("set_bug_report_broker_config", SetBugReportBrokerConfigReducer),
  __reducerSchema("set_bug_report_repo_shared", SetBugReportRepoSharedReducer),
  __reducerSchema("set_default_github_config", SetDefaultGithubConfigReducer),
  __reducerSchema("set_default_installation", SetDefaultInstallationReducer),
  __reducerSchema("set_github_app_config", SetGithubAppConfigReducer),
  __reducerSchema("set_github_app_install_url", SetGithubAppInstallUrlReducer),
  __reducerSchema("set_internal_notes", SetInternalNotesReducer),
  __reducerSchema("set_module_config", SetModuleConfigReducer),
  __reducerSchema("set_org_github_config", SetOrgGithubConfigReducer),
  __reducerSchema("set_org_installation", SetOrgInstallationReducer),
  __reducerSchema("set_repo_visibility_all_orgs", SetRepoVisibilityAllOrgsReducer),
  __reducerSchema("set_service_token", SetServiceTokenReducer),
  __reducerSchema("set_webclient_base_url", SetWebclientBaseUrlReducer),
  __reducerSchema("submit_bug_report", SubmitBugReportReducer),
  __reducerSchema("sync_deployment_config", SyncDeploymentConfigReducer),
  __reducerSchema("triage_bug_report", TriageBugReportReducer),
  __reducerSchema("unlink_bug_report", UnlinkBugReportReducer),
  __reducerSchema("update_bug_report_repo", UpdateBugReportRepoReducer),
  __reducerSchema("update_user_profile", UpdateUserProfileReducer),
  __reducerSchema("verify_bug_report_repo_install", VerifyBugReportRepoInstallReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
  __procedureSchema("auto_register_repos_for_install", AutoRegisterReposForInstallProcedure.params, AutoRegisterReposForInstallProcedure.returnType),
  __procedureSchema("request_attachment_download_url", RequestAttachmentDownloadUrlProcedure.params, RequestAttachmentDownloadUrlProcedure.returnType),
  __procedureSchema("request_attachment_upload_url", RequestAttachmentUploadUrlProcedure.params, RequestAttachmentUploadUrlProcedure.returnType),
  __procedureSchema("request_image_upload_url", RequestImageUploadUrlProcedure.params, RequestImageUploadUrlProcedure.returnType),
);

type __SchemaWithTableAccessorAliases = Omit<typeof tablesSchema.schemaType, "tables"> & {
  tables: typeof tablesSchema.schemaType.tables & {
    /** @deprecated Use `moduleConfig` instead. This alias will be removed in the next major version. */
    readonly "module_config": Omit<typeof tablesSchema.schemaType.tables["moduleConfig"], "accessorName"> & { readonly accessorName: "module_config" };
    /** @deprecated Use `allBugReportAttachments` instead. This alias will be removed in the next major version. */
    readonly "all_bug_report_attachments": Omit<typeof tablesSchema.schemaType.tables["allBugReportAttachments"], "accessorName"> & { readonly accessorName: "all_bug_report_attachments" };
    /** @deprecated Use `allBugReportComments` instead. This alias will be removed in the next major version. */
    readonly "all_bug_report_comments": Omit<typeof tablesSchema.schemaType.tables["allBugReportComments"], "accessorName"> & { readonly accessorName: "all_bug_report_comments" };
    /** @deprecated Use `allBugReportInternals` instead. This alias will be removed in the next major version. */
    readonly "all_bug_report_internals": Omit<typeof tablesSchema.schemaType.tables["allBugReportInternals"], "accessorName"> & { readonly accessorName: "all_bug_report_internals" };
    /** @deprecated Use `allBugReports` instead. This alias will be removed in the next major version. */
    readonly "all_bug_reports": Omit<typeof tablesSchema.schemaType.tables["allBugReports"], "accessorName"> & { readonly accessorName: "all_bug_reports" };
    /** @deprecated Use `myBugReportAttachments` instead. This alias will be removed in the next major version. */
    readonly "my_bug_report_attachments": Omit<typeof tablesSchema.schemaType.tables["myBugReportAttachments"], "accessorName"> & { readonly accessorName: "my_bug_report_attachments" };
    /** @deprecated Use `myBugReportComments` instead. This alias will be removed in the next major version. */
    readonly "my_bug_report_comments": Omit<typeof tablesSchema.schemaType.tables["myBugReportComments"], "accessorName"> & { readonly accessorName: "my_bug_report_comments" };
    /** @deprecated Use `myBugReportUser` instead. This alias will be removed in the next major version. */
    readonly "my_bug_report_user": Omit<typeof tablesSchema.schemaType.tables["myBugReportUser"], "accessorName"> & { readonly accessorName: "my_bug_report_user" };
    /** @deprecated Use `myBugReports` instead. This alias will be removed in the next major version. */
    readonly "my_bug_reports": Omit<typeof tablesSchema.schemaType.tables["myBugReports"], "accessorName"> & { readonly accessorName: "my_bug_reports" };
    /** @deprecated Use `myDeploymentConfig` instead. This alias will be removed in the next major version. */
    readonly "my_deployment_config": Omit<typeof tablesSchema.schemaType.tables["myDeploymentConfig"], "accessorName"> & { readonly accessorName: "my_deployment_config" };
    /** @deprecated Use `myGithubBugConfig` instead. This alias will be removed in the next major version. */
    readonly "my_github_bug_config": Omit<typeof tablesSchema.schemaType.tables["myGithubBugConfig"], "accessorName"> & { readonly accessorName: "my_github_bug_config" };
    /** @deprecated Use `orgBugReportAttachments` instead. This alias will be removed in the next major version. */
    readonly "org_bug_report_attachments": Omit<typeof tablesSchema.schemaType.tables["orgBugReportAttachments"], "accessorName"> & { readonly accessorName: "org_bug_report_attachments" };
    /** @deprecated Use `orgBugReportComments` instead. This alias will be removed in the next major version. */
    readonly "org_bug_report_comments": Omit<typeof tablesSchema.schemaType.tables["orgBugReportComments"], "accessorName"> & { readonly accessorName: "org_bug_report_comments" };
    /** @deprecated Use `orgBugReportInternals` instead. This alias will be removed in the next major version. */
    readonly "org_bug_report_internals": Omit<typeof tablesSchema.schemaType.tables["orgBugReportInternals"], "accessorName"> & { readonly accessorName: "org_bug_report_internals" };
    /** @deprecated Use `orgBugReportUsers` instead. This alias will be removed in the next major version. */
    readonly "org_bug_report_users": Omit<typeof tablesSchema.schemaType.tables["orgBugReportUsers"], "accessorName"> & { readonly accessorName: "org_bug_report_users" };
    /** @deprecated Use `orgBugReports` instead. This alias will be removed in the next major version. */
    readonly "org_bug_reports": Omit<typeof tablesSchema.schemaType.tables["orgBugReports"], "accessorName"> & { readonly accessorName: "org_bug_reports" };
    /** @deprecated Use `visibleBugReportRepos` instead. This alias will be removed in the next major version. */
    readonly "visible_bug_report_repos": Omit<typeof tablesSchema.schemaType.tables["visibleBugReportRepos"], "accessorName"> & { readonly accessorName: "visible_bug_report_repos" };
  };
};

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.14.0" as const,
  },
  tables: tablesSchema.schemaType.tables as __SchemaWithTableAccessorAliases["tables"],
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  __SchemaWithTableAccessorAliases,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

const tableAccessorAliases = {
  "module_config": "moduleConfig",
  "all_bug_report_attachments": "allBugReportAttachments",
  "all_bug_report_comments": "allBugReportComments",
  "all_bug_report_internals": "allBugReportInternals",
  "all_bug_reports": "allBugReports",
  "my_bug_report_attachments": "myBugReportAttachments",
  "my_bug_report_comments": "myBugReportComments",
  "my_bug_report_user": "myBugReportUser",
  "my_bug_reports": "myBugReports",
  "my_deployment_config": "myDeploymentConfig",
  "my_github_bug_config": "myGithubBugConfig",
  "org_bug_report_attachments": "orgBugReportAttachments",
  "org_bug_report_comments": "orgBugReportComments",
  "org_bug_report_internals": "orgBugReportInternals",
  "org_bug_report_users": "orgBugReportUsers",
  "org_bug_reports": "orgBugReports",
  "visible_bug_report_repos": "visibleBugReportRepos",
} as const;

function __withTableAccessorAliases<T extends object>(target: T, freeze = false): T {
  const out = Object.create(Object.getPrototypeOf(target)) as T & Record<string, unknown>;
  Object.defineProperties(out, Object.getOwnPropertyDescriptors(target));
  for (const [deprecatedAccessor, targetAccessor] of Object.entries(tableAccessorAliases)) {
    if (deprecatedAccessor in out) {
      continue;
    }
    Object.defineProperty(out, deprecatedAccessor, {
      enumerable: true,
      configurable: false,
      get: () => out[targetAccessor],
    });
  }
  return freeze ? Object.freeze(out) : out;
}

type __DbViewBase = __DbConnectionImpl<typeof REMOTE_MODULE>["db"];
export type DbView = __DbViewBase & {
  /** @deprecated Use `moduleConfig` instead. This alias will be removed in the next major version. */
  readonly "module_config": __DbViewBase["moduleConfig"];
  /** @deprecated Use `allBugReportAttachments` instead. This alias will be removed in the next major version. */
  readonly "all_bug_report_attachments": __DbViewBase["allBugReportAttachments"];
  /** @deprecated Use `allBugReportComments` instead. This alias will be removed in the next major version. */
  readonly "all_bug_report_comments": __DbViewBase["allBugReportComments"];
  /** @deprecated Use `allBugReportInternals` instead. This alias will be removed in the next major version. */
  readonly "all_bug_report_internals": __DbViewBase["allBugReportInternals"];
  /** @deprecated Use `allBugReports` instead. This alias will be removed in the next major version. */
  readonly "all_bug_reports": __DbViewBase["allBugReports"];
  /** @deprecated Use `myBugReportAttachments` instead. This alias will be removed in the next major version. */
  readonly "my_bug_report_attachments": __DbViewBase["myBugReportAttachments"];
  /** @deprecated Use `myBugReportComments` instead. This alias will be removed in the next major version. */
  readonly "my_bug_report_comments": __DbViewBase["myBugReportComments"];
  /** @deprecated Use `myBugReportUser` instead. This alias will be removed in the next major version. */
  readonly "my_bug_report_user": __DbViewBase["myBugReportUser"];
  /** @deprecated Use `myBugReports` instead. This alias will be removed in the next major version. */
  readonly "my_bug_reports": __DbViewBase["myBugReports"];
  /** @deprecated Use `myDeploymentConfig` instead. This alias will be removed in the next major version. */
  readonly "my_deployment_config": __DbViewBase["myDeploymentConfig"];
  /** @deprecated Use `myGithubBugConfig` instead. This alias will be removed in the next major version. */
  readonly "my_github_bug_config": __DbViewBase["myGithubBugConfig"];
  /** @deprecated Use `orgBugReportAttachments` instead. This alias will be removed in the next major version. */
  readonly "org_bug_report_attachments": __DbViewBase["orgBugReportAttachments"];
  /** @deprecated Use `orgBugReportComments` instead. This alias will be removed in the next major version. */
  readonly "org_bug_report_comments": __DbViewBase["orgBugReportComments"];
  /** @deprecated Use `orgBugReportInternals` instead. This alias will be removed in the next major version. */
  readonly "org_bug_report_internals": __DbViewBase["orgBugReportInternals"];
  /** @deprecated Use `orgBugReportUsers` instead. This alias will be removed in the next major version. */
  readonly "org_bug_report_users": __DbViewBase["orgBugReportUsers"];
  /** @deprecated Use `orgBugReports` instead. This alias will be removed in the next major version. */
  readonly "org_bug_reports": __DbViewBase["orgBugReports"];
  /** @deprecated Use `visibleBugReportRepos` instead. This alias will be removed in the next major version. */
  readonly "visible_bug_report_repos": __DbViewBase["visibleBugReportRepos"];
};

type __TablesBase = __QueryBuilder<typeof tablesSchema.schemaType>;
export type Tables = __TablesBase & {
  /** @deprecated Use `moduleConfig` instead. This alias will be removed in the next major version. */
  readonly "module_config": __TablesBase["moduleConfig"];
  /** @deprecated Use `allBugReportAttachments` instead. This alias will be removed in the next major version. */
  readonly "all_bug_report_attachments": __TablesBase["allBugReportAttachments"];
  /** @deprecated Use `allBugReportComments` instead. This alias will be removed in the next major version. */
  readonly "all_bug_report_comments": __TablesBase["allBugReportComments"];
  /** @deprecated Use `allBugReportInternals` instead. This alias will be removed in the next major version. */
  readonly "all_bug_report_internals": __TablesBase["allBugReportInternals"];
  /** @deprecated Use `allBugReports` instead. This alias will be removed in the next major version. */
  readonly "all_bug_reports": __TablesBase["allBugReports"];
  /** @deprecated Use `myBugReportAttachments` instead. This alias will be removed in the next major version. */
  readonly "my_bug_report_attachments": __TablesBase["myBugReportAttachments"];
  /** @deprecated Use `myBugReportComments` instead. This alias will be removed in the next major version. */
  readonly "my_bug_report_comments": __TablesBase["myBugReportComments"];
  /** @deprecated Use `myBugReportUser` instead. This alias will be removed in the next major version. */
  readonly "my_bug_report_user": __TablesBase["myBugReportUser"];
  /** @deprecated Use `myBugReports` instead. This alias will be removed in the next major version. */
  readonly "my_bug_reports": __TablesBase["myBugReports"];
  /** @deprecated Use `myDeploymentConfig` instead. This alias will be removed in the next major version. */
  readonly "my_deployment_config": __TablesBase["myDeploymentConfig"];
  /** @deprecated Use `myGithubBugConfig` instead. This alias will be removed in the next major version. */
  readonly "my_github_bug_config": __TablesBase["myGithubBugConfig"];
  /** @deprecated Use `orgBugReportAttachments` instead. This alias will be removed in the next major version. */
  readonly "org_bug_report_attachments": __TablesBase["orgBugReportAttachments"];
  /** @deprecated Use `orgBugReportComments` instead. This alias will be removed in the next major version. */
  readonly "org_bug_report_comments": __TablesBase["orgBugReportComments"];
  /** @deprecated Use `orgBugReportInternals` instead. This alias will be removed in the next major version. */
  readonly "org_bug_report_internals": __TablesBase["orgBugReportInternals"];
  /** @deprecated Use `orgBugReportUsers` instead. This alias will be removed in the next major version. */
  readonly "org_bug_report_users": __TablesBase["orgBugReportUsers"];
  /** @deprecated Use `orgBugReports` instead. This alias will be removed in the next major version. */
  readonly "org_bug_reports": __TablesBase["orgBugReports"];
  /** @deprecated Use `visibleBugReportRepos` instead. This alias will be removed in the next major version. */
  readonly "visible_bug_report_repos": __TablesBase["visibleBugReportRepos"];
};

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
const tablesBase: __TablesBase = __makeQueryBuilder(tablesSchema.schemaType);
export const tables: Tables = __withTableAccessorAliases(tablesBase, true) as Tables;

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The procedures available in this remote SpacetimeDB module. */
export const procedures = __convertToAccessorMap(proceduresSchema.procedures);

/** The context type returned in callbacks for all possible events. */
export type EventContext = Omit<__EventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = Omit<__ReducerEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = Omit<__SubscriptionEventContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The context type returned in callbacks for error events. */
export type ErrorContext = Omit<__ErrorContextInterface<typeof REMOTE_MODULE>, "db"> & { db: DbView };
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  declare db: DbView;

  constructor(config: __DbConnectionConfig<typeof REMOTE_MODULE>) {
    super(config);
    this.db = __withTableAccessorAliases(this.db) as DbView;
  }

  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

